export default "__VITE_ASSET__C2krTusx__"